import { render, staticRenderFns } from "./activityRedirect.vue?vue&type=template&id=bcbb3ef0&scoped=true"
import script from "./activityRedirect.vue?vue&type=script&lang=js"
export * from "./activityRedirect.vue?vue&type=script&lang=js"
import style0 from "./activityRedirect.vue?vue&type=style&index=0&id=bcbb3ef0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbb3ef0",
  null
  
)

export default component.exports